import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

export function listenForRouteChange(
  router: Router,
  destroy$: Observable<void | unknown>,
  keyword: string = 'maps'
) {
  return router.events.pipe(
    takeUntil(destroy$),
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map((event) => event.url.includes(keyword))
  );
}
